import disableAnimationPropsDurations from '@utils/helpers/disableAnimationPropsDurations';
import { type MotionProps, motion, useReducedMotion } from 'framer-motion';
import {
  type ComponentPropsWithoutRef,
  type ElementType,
  type Ref,
  useMemo,
} from 'react';

type HTMLElementTag = keyof HTMLElementTagNameMap;
type MotionWrapperProps<T extends HTMLElementTag = 'div'> = {
  readonly tag?: T;
  readonly ref?: Ref<HTMLElementTagNameMap[T]>;
} & MotionProps &
  Omit<ComponentPropsWithoutRef<T>, keyof MotionProps | 'ref'>;

const MotionWrapper = <T extends HTMLElementTag = 'div'>({
  tag,
  ref,
  variants,
  initial,
  animate,
  exit,
  transition,
  layout,
  whileHover,
  ...rest
}: MotionWrapperProps<T>) => {
  const MotionComponent: ElementType = useMemo(
    () => motion[(tag || 'div') as keyof typeof motion],
    [tag]
  );
  const prefersReducedMotion = useReducedMotion();
  const animationConfigProps = {
    variants,
    initial,
    animate,
    exit,
    transition,
    whileHover,
  };

  return (
    <MotionComponent
      ref={ref}
      {...(prefersReducedMotion
        ? disableAnimationPropsDurations(animationConfigProps)
        : animationConfigProps)}
      layout={prefersReducedMotion ? false : layout}
      {...rest}
    />
  );
};

export default MotionWrapper;
